<template>
  <div class="container">
    <div class="left-column">
      <div class="image-container centered">
        <img :src="profileImage" class="shrink-circular-image" />
      </div>
      <h2 class="h2_gap">{{ dd.fullname }}</h2>
      <p><i class="fa-solid fa-address-card"></i> <i>{{ dd.position }}</i></p>
      <p><i class="fa-solid fa-envelope"></i> {{ dd.email }}</p>
      <p v-if="dd.homepage"><i class="fas fa-globe"></i> <a :href="dd.homepage" target="_blank">Homepage</a></p>
      <p v-if="dd.linkedin"><i class="fa-brands fa-linkedin"></i> <a :href="dd.linkedin" target="_blank">LinkedIn</a>
      </p>
      <p v-if="dd.github"><i class="fa-brands fa-github"></i> <a :href="dd.github" target="_blank">Github</a></p>
      <p v-if="dd.scholar"><i class="fa-brands fa-google"></i> <a :href="dd.scholar" target="_blank">Google Scholar</a>
      </p>
      <p v-if="dd.dblp"><i class="fa-solid fa-circle-nodes"></i> <a :href="dd.dblp" target="_blank">DBLP</a></p>

    </div>
    <div class="middle-column" style="margin-left: 15px;">
      <div v-if="dd.description" v-html="dd.description" style="text-align: justify"></div>
      <div>
        <v-btn-toggle class="align-center" align-center v-model="activeSection" tile color="deep-purple accent-3" group mandatory>
          <v-btn v-if="showConferences" value="conference" href="#Conferencepapers">
            Conference papers
          </v-btn>
          <v-btn v-if="showJournals" value="journal" href="#Journals">
            Journals
          </v-btn>
          <v-btn v-if="showBooks" value="book" href="#Books">
            Books
          </v-btn>
        </v-btn-toggle>
        <div>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </div>

        <v-card v-if="activeSection === 'conference'" class="mx-auto">
          <v-card-text class="py-0">
            <v-list>
              <template v-for="conference in conferences">
                <v-list-item :key="conference.name">
                  <v-list-item-content>
                    <div class="d-flex justify-start pr-3"><v-list-item-title v-html="conference.name"
                        class="font-weight-medium text-wrap"></v-list-item-title>
                    </div>
                    <v-list-item-title class="text-wrap">
                      <span v-html="conference.authors"></span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-wrap">
                      <span v-html="conference.journal"></span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="text-wrap">
                      <span v-if="conference.paperLink" class="mr-2">
                        <a :href="conference.paperLink" target="_blank"><i
                            class="fa-solid fa-file-lines"></i>&nbsp;Publication</a>
                      </span>
                      <span v-if="conference.pdfLink" class="mr-2">
                        <a :href="conference.pdfLink" target="_blank"><i class="fa-solid fa-file-pdf"></i>&nbsp;PDF</a>
                      </span>
                      <span v-if="conference.preprintLink" class="mr-2">
                        <a :href="conference.preprintLink" target="_blank"><i
                            class="fa-solid fa-print"></i>&nbsp;Preprint</a>
                      </span>
                      <span v-if="conference.codeLink" class="mr-2">
                        <a :href="conference.codeLink" target="_blank"><i class="fa-solid fa-code"></i>&nbsp;Code</a>
                      </span>
                      <span v-if="conference.slideLink" class="mr-2">
                        <a :href="conference.slideLink" target="_blank"><i
                            class="fa-solid fa-display"></i>&nbsp;Slides</a>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>


        <v-card v-if="activeSection === 'journal'" class="mx-auto">
          <v-card-text class="py-0">
            <v-list>
              <template v-for="journal in journals">
                <v-list-item :key="journal.name">
                  <v-list-item-content>
                    <div class="d-flex justify-start pr-3"><v-list-item-title v-html="journal.name"
                        class="font-weight-medium text-wrap"></v-list-item-title>
                    </div>

                    <!-- <v-list-item-title v-html="journal.authors" style="white-space: normal"><strong>Authors:</strong>
                    </v-list-item-title> -->

                    <v-list-item-title class="text-wrap">
                      <span v-html="journal.authors"></span>
                    </v-list-item-title>


                    <v-list-item-subtitle class="text-wrap">
                      <span v-html="journal.journal"></span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="text-wrap">
                      <span v-if="journal.paperLink" class="mr-2">
                        <a :href="journal.paperLink" target="_blank"><i
                            class="fa-solid fa-file-lines"></i>&nbsp;Publication</a>
                      </span>
                      <span v-if="journal.pdfLink" class="mr-2">
                        <a :href="journal.pdfLink" target="_blank"><i class="fa-solid fa-file-pdf"></i>&nbsp;PDF</a>
                      </span>
                      <span v-if="journal.preprintLink" class="mr-2">
                        <a :href="journal.preprintLink" target="_blank"><i
                            class="fa-solid fa-print"></i>&nbsp;Preprint</a>
                      </span>
                      <span v-if="journal.codeLink" class="mr-2">
                        <a :href="journal.codeLink" target="_blank"><i class="fa-solid fa-code"></i>&nbsp;Code</a>
                      </span>
                      <span v-if="journal.slideLink" class="mr-2">
                        <a :href="journal.slideLink" target="_blank"><i class="fa-solid fa-display"></i>&nbsp;Slides</a>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>

        <v-card v-if="activeSection === 'book' " class="mx-auto">
          <v-card-text class="py-0">
            <v-list>
              <template v-for="book in books">
                <v-list-item :key="book.name">
                  <v-list-item-content>
                    <div class="d-flex justify-start pr-3"><v-list-item-title v-html="book.name"
                        class="font-weight-medium text-wrap"></v-list-item-title>
                    </div>

                    <v-list-item-title class="text-wrap">
                      <span v-html="book.authors"></span>
                    </v-list-item-title>


                    <!-- <v-list-item-title v-html="book.authors" style="white-space: normal"><strong>Authors:</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle v-html="book.journal"
                      class="text-wrap"><strong>Journal:</strong></v-list-item-subtitle> -->


                    <v-list-item-subtitle class="text-wrap">
                      <span v-html="book.journal"></span>
                    </v-list-item-subtitle>


                    <v-list-item-subtitle class="text-wrap">
                      <span v-if="book.paperLink" class="mr-2">
                        <a :href="book.paperLink" target="_blank"><i
                            class="fa-solid fa-file-lines"></i>&nbsp;Publication</a>
                      </span>
                      <span v-if="book.pdfLink" class="mr-2">
                        <a :href="book.pdfLink" target="_blank"><i class="fa-solid fa-file-pdf"></i>&nbsp;PDF</a>
                      </span>
                      <span v-if="book.preprintLink" class="mr-2">
                        <a :href="book.preprintLink" target="_blank"><i class="fa-solid fa-print"></i>&nbsp;Preprint</a>
                      </span>
                      <span v-if="book.codeLink" class="mr-2">
                        <a :href="book.codeLink" target="_blank"><i class="fa-solid fa-code"></i>&nbsp;Code</a>
                      </span>
                      <span v-if="book.slideLink" class="mr-2">
                        <a :href="book.slideLink" target="_blank"><i class="fa-solid fa-display"></i>&nbsp;Slides</a>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>

      </div>
    </div>
  </div>
</template>

<style>
.container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.left-column {
  width: 30%;
}

.middle-column {
  width: 70%;
}

.image-container {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}

ul {
  padding: 0;
  /* Remove default padding */
  list-style: none;
  /* Remove list bullet/number */
}

li {
  margin: 0px;
  /* Adjust the margin as needed to reduce vertical spacing */
}

li p {
  line-height: 0.9;
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.shrink-circular-image {
  width: 100%;
  height: auto;
}

.h2_gap {
  margin-top: 40px;
  /* Increase the space between the image and full name */
}
</style>

<script>
import PUBLICATIONS from './json/publications.json';

export default {
  data() {
    return {
      activeSection: 'conference',

      dd: null,
      journals: [],
      conferences: [],
      books: [],
      profileImage: '',
      showJournals: false,
      showConferences: false,
      showBooks: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  async created() {
    const jsonFileMapping = {
      Katerina: 'katerina.json',
      Angelina: 'angelina.json',
      Nan: 'nan.json',
      Jenit: 'jenit.json',
      Alice: 'alice.json',
      Florias: 'florias.json',
      Subhranil: 'subhranil.json',
      Jannis: 'jannis.json',
      Wilson: 'wilson.json'
    };
    const jsonFile = jsonFileMapping[this.id];

    try {
      this.dd = require(`./json/members/${jsonFile}`);
    } catch (error) {
      console.error(`Error loading JSON data: ${error}`);
    }

    const authorNamesMapping = {
  Katerina: { abbreviated: 'A. Mitrokotsa', full: 'Aikaterini Mitrokotsa' },
  Angelina: { abbreviated: 'A. Makrai', full: 'Makrai Angelina' },
  Nan: { abbreviated: 'N. Cheng', full: 'Nan Cheng' },
  Jenit: { abbreviated: 'J. Tomy', full: 'Jenit Tomy' },
  Alice: { abbreviated: 'L. Yu', full: 'Liujun Yu' },
  Florias: { abbreviated: 'F. Papadopoulos', full: 'Florias Papadopoulos' },
  Subhranil: { abbreviated: 'S. Dutta', full: 'Subhranil Dutta' },
  Jannis: { abbreviated: 'I. Katis', full: 'Ioannis Katis' },
  Wilson: { abbreviated: 'W. Tsuata', full: 'Wilson Tsuata' }
};

try {
  // Get both abbreviated and full names for the member
  const { abbreviated, full } = authorNamesMapping[this.id] || {};

  if (!abbreviated || !full) {
    throw new Error(`No author names found for member ID: ${this.id}`);
  }

  // Filter publications by media type and author name (abbreviated or full)
  this.journals = PUBLICATIONS.filter(item => 
    item.media === 'journal' && 
    (item.authors.includes(abbreviated) || item.authors.includes(full))
  );
  this.conferences = PUBLICATIONS.filter(item => 
    item.media === 'conference' && 
    (item.authors.includes(abbreviated) || item.authors.includes(full))
  );
  this.books = PUBLICATIONS.filter(item => 
    item.media === 'book' && 
    (item.authors.includes(abbreviated) || item.authors.includes(full))
  );

  // Set visibility flags
  this.showJournals = this.journals.length > 0;
  this.showConferences = this.conferences.length > 0;
  this.showBooks = this.books.length > 0;
} catch (error) {
  console.error(`Error processing publications JSON: ${error}`);
}

    this.profileImage = this.imgPath();

    if(this.showConferences){
      this.activeSection = 'conference';
    } else if (this.showJournals) {
      this.activeSection = 'journal';
    } else if (this.showBooks) {
      this.activeSection = 'book';
    }else{
      this.activeSection = 'none';
    }
  },
  methods: {
    imgPath() {
      // Determine the image filename based on the route parameter
      const imageFileName = require('./images/members/' + this.id + '.jpeg');
      return imageFileName;
    },
  },
};
</script>